import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/HomeView',
    name: 'home',
    component: HomeView
  },
  {
    path: '/DetailView',
    name: 'DetailView',
    // route level code-splitting
    // this generates a separate chunk (DetailView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "DetailView" */ '../views/DetailView.vue')
    }
  },
  {
    path: '/choiceView',
    name: 'choiceView',
    // route level code-splitting
    // this generates a separate chunk (choiceView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "choiceView" */ '../views/choiceView.vue')
    }
  },
  {
    path: '/DownloadView',
    name: 'DownloadView',
    // route level code-splitting
    // this generates a separate chunk (DownloadView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "DownloadView" */ '../views/DownloadView.vue')
    }
  },
  {
    path: '/PostView',
    name: 'PostView',
    // route level code-splitting
    // this generates a separate chunk (PostView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "PostView" */ '../views/PostView.vue')
    }
  },
  {
    path: '/BuyteamView',
    name: 'BuyteamView',
    // route level code-splitting
    // this generates a separate chunk (BuyteamView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "BuyteamView" */ '../views/BuyteamView.vue')
    }
  },
  {
    path: '/CouponView',
    name: 'CouponView',
    // route level code-splitting
    // this generates a separate chunk (CouponView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "CouponView" */ '../views/CouponView.vue')
    }
  },
  {
    path: '/CardView',
    name: 'CardView',
    // route level code-splitting
    // this generates a separate chunk (CardView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "CardView" */ '../views/CardView.vue')
    }
  },
  {
    path: '/clauseView',
    name: 'clauseView',
    // route level code-splitting
    // this generates a separate chunk (clauseView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "clauseView" */ '../views/clauseView.vue')
    }
  },
  {
    path: '/VideoView',
    name: 'VideoView',
    // route level code-splitting
    // this generates a separate chunk (VideoView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "VideoView" */ '../views/VideoView.vue')
    }
  },
  {
    path: '/VerticalTextSlider',
    name: 'VerticalTextSlider',
    // route level code-splitting
    // this generates a separate chunk (VerticalTextSlider.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "VerticalTextSlider" */ '../views/VerticalTextSlider.vue')
    }
  },
  {
    path: '/TurntableView',
    name: 'TurntableView',
    // route level code-splitting
    // this generates a separate chunk (TurntableView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "TurntableView" */ '../views/TurntableView.vue')
    }
  },
  {
    path: '/scrollpage',
    name: 'scrollpage',
    // route level code-splitting
    // this generates a separate chunk (scrollpage.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "scrollpage" */ '../views/scrollpage.vue')
    }
  },
  {
    path: '/productIntroduction',
    name: 'productIntroduction',
    // route level code-splitting
    // this generates a separate chunk (productIntroduction.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "productIntroduction" */ '../views/productIntroduction.vue')
    }
  },
  {
    path: '/DailygoodcardView',
    name: 'DailygoodcardView',
    // route level code-splitting
    // this generates a separate chunk (DailygoodcardView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "DailygoodcardView" */ '../views/DailygoodcardView.vue')
    }
  },
  {
    path: '/Turntableall',
    name: 'Turntableall',
    // route level code-splitting
    // this generates a separate chunk (Turntableall.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "Turntableall" */ '../views/Turntableall.vue')
    }
  },
  {
    path: '/miniprogram',
    name: 'Miniprogram',
    // route level code-splitting
    // this generates a separate chunk (miniprogram.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "miniprogram" */ '../views/miniprogram.vue')
    }
  },
  {
    path: '/storeredirect',
    name: 'Storeredirect',
    // route level code-splitting
    // this generates a separate chunk (storeredirect.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "storeredirect" */ '../views/storeredirect.vue')
    }
  },
  // 问卷调查
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    // route level code-splitting
    // this generates a separate chunk (questionnaire.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "questionnaire" */ '../views/questionnaire.vue')
    }
  },
  // 微信小程序打开app
  {
    path: '/Wxopenapp',
    name: 'Wxopenapp',
    // route level code-splitting
    // this generates a separate chunk (Wxopenapp.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "Wxopenapp" */ '../views/Wxopenapp.vue')
    }
  },
  // 分享列表（查看谁帮忙分享了）
  {
    path: '/RewardView',
    name: 'RewardView',
    // route level code-splitting
    // this generates a separate chunk (RewardView.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "RewardView" */ '../views/RewardView.vue')
    }
  },
  // 二维码核销（app端进行扫码）
  {
    path: '/ScanQrcode',
    name: 'ScanQrcode',
    // route level code-splitting
    // this generates a separate chunk (ScanQrcode.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "ScanQrcode" */ '../views/ScanQrcode.vue')
    }
  },
  // 中网展示页面1
  {
    path: '/Chinaopenfirst',
    name: 'Chinaopenfirst',
    // route level code-splitting
    // this generates a separate chunk (Chinaopenfirst.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "Chinaopenfirst" */ '../views/Chinaopenfirst.vue')
    }
  },
  // 中网展示页面2(此页面目前没用)
  {
    path: '/Chinaopensecond',
    name: 'Chinaopensecond',
    // route level code-splitting
    // this generates a separate chunk (Chinaopensecond.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "Chinaopensecond" */ '../views/Chinaopensecond.vue')
    }
  },
  // 游戏
  {
    path: '/game',
    name: 'Game',
    // route level code-splitting
    // this generates a separate chunk (game.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "game" */ '../views/game.vue')
    }
  }
  
  
  
]

const router = new VueRouter({
  mode: 'history',
  base: '/blindboxs/',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
